export const BatchResultclaimStatus = [
  {
    status: 'Paid or Approved',
    title: 'Paid / Approved',
    count: 0,
    variant: 'success',
  },
  {
    status: 'Denied',
    title: 'Denied',
    count: 0,
    variant: 'danger',
  },
  {
    status: 'Rejected',
    title: 'Rejected',
    count: 0,
    variant: 'danger',
  },
  {
    status: 'Pending',
    title: 'Pending',
    count: 0,
    variant: 'info',
  },
  {
    status: 'Processing',
    title: 'Processing',
    count: 0,
    variant: 'info',
  },
  {
    status: 'Claim not on file',
    title: 'Claim not on file',
    count: 0,
    variant: 'default',
  },
  {
    status: 'Claim on File',
    title: 'Claim on File',
    count: 0,
    variant: 'warning',
  },
  {
    status: 'Coverage Issue',
    title: 'Coverage Issue',
    count: 0,
    variant: 'warning',
  },
  {
    status: 'IVR Response',
    title: 'IVR Response',
    count: 0,
    variant: 'warning',
  },
  {
    status: 'Undefined',
    title: 'Undefined',
    count: 0,
    variant: 'warning',
  },
]
